// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Modules
import { DocumentArchiveDossierDialogModule } from 'src/app/modules/properties/document-archive-dossier-dialog.module';
import { DocumentArchiveExportDialogsModule } from 'src/app/modules/properties/document-archive-export-dialogs.module';
import { MappingArchiveDocsDialogModule } from 'src/app/modules/properties/mapping-archive-docs-dialog.module';
import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';
import { PropertiesRoutingModule } from './properties-routing.module';

// Custom packages - Components
import { AddPhonebookContactDialogComponent } from 'src/app/modules/properties/components/add-phonebook-dialog/add-phonebook-dialog.component';
import { PropertyDetailDocumentInsertDialogComponent } from 'src/app/modules/properties/components/document-insert-dialog/document-insert-dialog.component';
import { PropertyDetailDocumentItemDialogComponent } from 'src/app/modules/properties/components/document-item-dialog/document-item-dialog.component';
import { PropertyDetailDocumentItemPrintDialogComponent } from 'src/app/modules/properties/components/document-item-print-dialog/document-item-print-dialog.component';
import { PropertyDetailDocumentNoteDialogComponent } from 'src/app/modules/properties/components/document-note-dialog/document-note-dialog.component';
import { PropertyDetailDocumentPrintModuleDialogComponent } from 'src/app/modules/properties/components/document-print-module-dialog/document-print-module-dialog.component';
import { EditPhonebookContactDialogComponent } from 'src/app/modules/properties/components/edit-phonebook-dialog/edit-phonebook-dialog.component';
import { ExportCdDocsDialogComponent } from 'src/app/modules/properties/components/export-cd-docs-dialog/export-cd-docs-dialog.component';
import { ExportContractsDialogComponent } from 'src/app/modules/properties/components/export-contracts-dialog/export-contracts-dialog.component';
import { ExportRasDocsDialogComponent } from 'src/app/modules/properties/components/export-ras-docs-dialog/export-ras-docs-dialog.component';
import { ConductorManagementDialogComponent } from 'src/app/modules/properties/components/conductor-management-dialog/conductor-management-dialog.component';
import { InterventionArchivingDialogComponent } from 'src/app/modules/properties/components/intervention-archiving-dialog/intervention-archiving-dialog.component';
import { PropertyDetailMappingDeleteDialogComponent } from 'src/app/modules/properties/components/mapping-delete-dialog/mapping-delete-dialog.component';
import { PropertyDetailMappingItemDialogComponent } from 'src/app/modules/properties/components/mapping-item-dialog/mapping-item-dialog.component';
import { PropertyDetailMappingNoteDialogComponent } from 'src/app/modules/properties/components/mapping-note-dialog/mapping-note-dialog.component';
import { PropertyDetailMappingRemakeDialogComponent } from 'src/app/modules/properties/components/mapping-remake-dialog/mapping-remake-dialog.component';
import { PropertyDetailMappingTabComponent } from 'src/app/modules/properties/components/mapping-tab/mapping-tab.component';
import { AdminCompanyPrivacySagDialogComponent } from 'src/app/modules/properties/components/admin-company-privacy-sag-dialog/admin-company-privacy-sag-dialog.component';
import { PrivacyDocsListDialogComponent } from 'src/app/modules/properties/components/privacy-docs-list-dialog/privacy-docs-list-dialog.component';
import { SendEmailDialogComponent } from 'src/app/modules/properties/components/send-email-dialog/send-email-dialog.component';
import { AddPropertyComponent } from 'src/app/modules/properties/pages/add-property/add-property.page';
import { PropertiesListComponent } from 'src/app/modules/properties/pages/properties-list/properties-list.page';
import { PropertyAddDocumentsComponent } from "src/app/modules/properties/pages/property-add-documents/property-add-documents.page";
import { PropertyAddNewDocumentsComponent } from "src/app/modules/properties/pages/property-add-new-documents/property-add-new-documents.page";
import { PropertyBalancesComponent } from "src/app/modules/properties/pages/property-balances/property-balances.page";
import { PropertyCaretakersComponent } from "src/app/modules/properties/pages/property-caretakers/property-caretakers.page";
import { PropertyCondominiumAccessComponent } from "src/app/modules/properties/pages/property-condominium-access/property-condominium-access.page";
import { PropertyDetailComponent } from 'src/app/modules/properties/pages/property-detail/property-detail.page';
import { PropertyDetail2Component } from "src/app/modules/properties/pages/property-detail2/property-detail2.page";
import { PropertyDocumentsWithExpiration } from "src/app/modules/properties/pages/property-documents-expiration/property-documents-expiration.page";
import { PropertyDocumentsComponent } from 'src/app/modules/properties/pages/property-documents/property-documents.page';
import { PropertyHomeComponent } from "src/app/modules/properties/pages/property-home/property-home.page";
import { PropertyMappingComponent } from 'src/app/modules/properties/pages/property-mapping/property-mapping.page';
import { PropertyStatusComponent } from "src/app/modules/properties/pages/property-status/property-status.page";
import { ViewPropertyComponent } from "src/app/modules/properties/pages/view-property/view-property.page";
import { ViewStructureDialogComponent } from 'src/app/shared/components/dialogs/view-structure-dialog/view-structure-dialog.component';
import { AddStatementDialogComponent } from './components/add-statement-dialog/add-statement-dialog.component';
import { AddRemappingDialogComponent } from './components/add-remapping-dialog/add-remapping-dialog.component';
import { RemappingListDialogComponent } from './components/remapping-list-dialog/remapping-list-dialog.component';
import { CancelContractDialogComponent } from './components/cancel-contract-dialog/cancel-contract-dialog.component';
import { PropertyExpireContractItemDialogComponent } from './components/contract-expire-item-dialog/contract-expire-item-dialog.component';
import { PropertyDeleteDocumentItemDialogComponent } from './components/document-delete-item-dialog/document-delete-item-dialog.component';
import { PropertySameCodeEditDialogComponent } from './components/document-same-code-edit-dialog/document-same-code-edit-dialog.component';
import { DocumentDownloadDialogComponent } from './components/document-download-dialog/document-download-dialog.component';
import { PropertyEditNoteDialogComponent } from './components/document-edit-note-dialog/document-edit-note-dialog.component';
import { DocumentPaperInsertDialogComponent } from './components/document-paper-insert-dialog/document-paper-insert-dialog.component';
import { EditStatementDialogComponent } from './components/edit-statement-dialog/edit-statement-dialog.component';
import { NfcDetailDialogComponent } from './components/nfc-access-logs/components/nfc-detail-dialog/nfc-detail-dialog.component';
import { NfcAccessLogsListComponent } from './components/nfc-access-logs/pages/access-logs-list/nfc-access-logs-list.page';
import { PropertiesSuspendedListComponent } from './pages/properties-suspended-list/properties-suspended-list.page';
import { SearchDocumentsComponent } from './pages/property-documents/search-documents/search-documents.page.component';

import { AddPlatformNoteDialogComponent } from 'src/app/components/platform-note-card/components/add-platform-note-dialog/add-platform-note-dialog.component';
import { AssociateBalancesPlatformNoteDialogComponent } from "src/app/components/platform-note-card/components/associate-balances-platform-note-dialog/associate-balances-platform-note-dialog.component";
import { EditPlatformNoteDialogComponent } from 'src/app/components/platform-note-card/components/edit-platform-note-dialog/edit-platform-note-dialog.component';
import { ViewPlatformNoteDialogComponent } from 'src/app/components/platform-note-card/components/view-platform-note-dialog/view-platform-note-dialog.component';

import { AssignTaggerDialogComponent } from 'src/app/modules/properties/components/assign-tagger-dialog/assign-tagger-dialog.component';
import { AssignTaggersDialogComponent } from 'src/app/modules/properties/components/assign-taggers-dialog/assign-taggers-dialog.component';
import { CompanyPlatformNotesDialogComponent } from 'src/app/modules/properties/components/company-platfom-notes-dialog/company-platform-notes-dialog.component';
import { PropertyDetailMappingViewDialogComponent } from "src/app/modules/properties/components/mapping-view-dialog/mapping-view-dialog.component";
import { PropertyTagNfcListDialogComponent } from 'src/app/modules/properties/components/property-tag-nfc-list-dialog/property-tag-nfc-list-dialog.component';
import { PropertiesNfcListComponent } from 'src/app/modules/properties/pages/properties-nfc-list/properties-nfc-list.page';
import { PropertyLatestDocumentsInsertedComponent } from "src/app/modules/properties/pages/property-latest-documents-inserted/property-latest-documents-inserted.page";
import { PropertyNotesContractualAgreements } from "src/app/modules/properties/pages/property-notes-contractual/property-notes-contractual.page";
import { PropertyPropertyPropertyTagNfcList } from "src/app/modules/properties/pages/property-property-tag-nfc-list/property-property-tag-nfc-list.page";
import { PropertyPropertyPropertyTangNfc } from "src/app/modules/properties/pages/property-property-tang-nfc/property-property-tang-nfc.page";
import { PropertyTagNfcListComponent } from "src/app/modules/properties/pages/property-tag-nfc-list/property-tag-nfc-list.page";
import { PropertyTagNfcAddDialogComponent } from './components/property-tag-nfc-add-dialog/property-tag-nfc-add-dialog.component';
import { PropertyTagNfcEditDialogComponent } from './components/property-tag-nfc-edit-dialog/property-tag-nfc-edit-dialog.component';
import { PropertyTagNfcReassignDialogComponent } from './components/property-tag-nfc-reassign-dialog/property-tag-nfc-reassign-dialog.component';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    PropertiesRoutingModule,
    PublicModule,
    // The pages of the 3.0.0 archive are NOT here: each one has its lazy module (pages/*-v3), with
    // DocumentArchiveV3Module for their dialogs, so that none of them lands in the initial bundle
    // The exception: the dialog of the mapping tab on the 3.0.0 archive (MAP-A1), with «Scarica i
    // documenti», since the mapping tab that opens it is declared here
    MappingArchiveDocsDialogModule,
    // The same for the dossier zip of the 3.0.0 archive (NEW-M17): the buttons that open it are on
    // pages of the initial bundle (property home, property lists, statistics)
    DocumentArchiveDossierDialogModule,
    // And for «Esporta RAS» and «Esporta contratti» of the 3.0.0 archive: with the switch live, the
    // property home and the mapping open them in place of the legacy dialogs
    DocumentArchiveExportDialogsModule,
  ],
  declarations: [
    PropertiesListComponent,
    PropertyDetailComponent,
    PropertyMappingComponent,
    PropertyDocumentsComponent,
    AddPropertyComponent,
    PropertiesSuspendedListComponent,

    PropertyDetailMappingTabComponent,
    PropertyDetailMappingItemDialogComponent,
    PropertyDetailDocumentItemDialogComponent,
    PropertyDetailDocumentPrintModuleDialogComponent,
    ViewPropertyComponent,
    PropertyDetailMappingNoteDialogComponent,
    PropertyDetailMappingRemakeDialogComponent,
    PropertyDetailMappingDeleteDialogComponent,
    PropertyCaretakersComponent,
    PropertyDetailDocumentNoteDialogComponent,
    PropertyAddDocumentsComponent,
    PropertyDetailDocumentInsertDialogComponent,
    SearchDocumentsComponent,
    PropertyDetailDocumentItemPrintDialogComponent,
    DocumentDownloadDialogComponent,
    AddPhonebookContactDialogComponent,
    EditPhonebookContactDialogComponent,
    SendEmailDialogComponent,
    CancelContractDialogComponent,
    PropertyDeleteDocumentItemDialogComponent,
    ViewStructureDialogComponent,
    DocumentPaperInsertDialogComponent,
    NfcAccessLogsListComponent,
    NfcDetailDialogComponent,
    PropertyExpireContractItemDialogComponent,
    PropertyEditNoteDialogComponent,
    ExportCdDocsDialogComponent,
    ExportContractsDialogComponent,
    ExportRasDocsDialogComponent,
    PrivacyDocsListDialogComponent,
    AdminCompanyPrivacySagDialogComponent,
    AddStatementDialogComponent,
    EditStatementDialogComponent,
    PropertyAddNewDocumentsComponent,

    PropertyHomeComponent,
    PropertyDocumentsWithExpiration,
    PropertyCondominiumAccessComponent,
    PropertyDetail2Component,
    PropertyStatusComponent,
    PropertyBalancesComponent,

    CompanyPlatformNotesDialogComponent,

    PropertiesNfcListComponent,
    AssignTaggerDialogComponent,
    PropertyTagNfcListDialogComponent,
    PropertyTagNfcEditDialogComponent,
    PropertyTagNfcAddDialogComponent,
    PropertyTagNfcReassignDialogComponent,
    AssignTaggersDialogComponent,

    PropertyTagNfcListComponent,
    PropertyDetailMappingViewDialogComponent,
    PropertyNotesContractualAgreements,
    PropertyPropertyPropertyTangNfc,
    PropertyPropertyPropertyTagNfcList,
    PropertyLatestDocumentsInsertedComponent,
    AddRemappingDialogComponent,
    RemappingListDialogComponent,
    InterventionArchivingDialogComponent,
    ConductorManagementDialogComponent,
    PropertySameCodeEditDialogComponent,
  ],
  exports: [
    PropertyDetailMappingItemDialogComponent,
    PropertyDetailDocumentItemDialogComponent,
    PropertyDetailDocumentPrintModuleDialogComponent,
    PropertyDetailMappingNoteDialogComponent,
    PropertyDetailMappingRemakeDialogComponent,
    PropertyDetailMappingDeleteDialogComponent,
    PropertyDetailDocumentNoteDialogComponent,
    PropertyDetailDocumentInsertDialogComponent,
    PropertyDetailDocumentItemPrintDialogComponent,
    DocumentDownloadDialogComponent,
    PropertyDeleteDocumentItemDialogComponent,
    PropertyExpireContractItemDialogComponent,
    PropertyEditNoteDialogComponent,
    ExportCdDocsDialogComponent,
    ExportContractsDialogComponent,
    ExportRasDocsDialogComponent,
    PropertyDetailMappingViewDialogComponent,
  ],
  entryComponents: [
    AddRemappingDialogComponent,
    RemappingListDialogComponent,
    AddPhonebookContactDialogComponent,
    EditPhonebookContactDialogComponent,
    SendEmailDialogComponent,
    CancelContractDialogComponent,
    ViewStructureDialogComponent,
    DocumentPaperInsertDialogComponent,
    NfcDetailDialogComponent,
    AddStatementDialogComponent,
    EditStatementDialogComponent,
    AddPlatformNoteDialogComponent,
    ViewPlatformNoteDialogComponent,
    EditPlatformNoteDialogComponent,
    CompanyPlatformNotesDialogComponent,
    AssociateBalancesPlatformNoteDialogComponent,
    AssignTaggerDialogComponent,
    PropertyTagNfcListDialogComponent,
    PropertyTagNfcEditDialogComponent,
    PropertyTagNfcAddDialogComponent,
    PropertyTagNfcReassignDialogComponent,
    AssignTaggersDialogComponent,
    PropertyDetailDocumentItemDialogComponent,
    PropertyDetailMappingItemDialogComponent,
    PropertyDetailDocumentPrintModuleDialogComponent,
    PropertyDetailMappingNoteDialogComponent,
    PropertyDetailMappingRemakeDialogComponent,
    PropertyDetailMappingDeleteDialogComponent,
    PropertyDetailDocumentNoteDialogComponent,
    PropertyDetailDocumentInsertDialogComponent,
    PropertyDetailDocumentItemPrintDialogComponent,
    DocumentDownloadDialogComponent,
    PropertyDeleteDocumentItemDialogComponent,
    PropertyExpireContractItemDialogComponent,
    PropertyEditNoteDialogComponent,
    ExportCdDocsDialogComponent,
    ExportContractsDialogComponent,
    ExportRasDocsDialogComponent,
    PrivacyDocsListDialogComponent,
    AdminCompanyPrivacySagDialogComponent,
    PropertyDetailMappingViewDialogComponent,
    InterventionArchivingDialogComponent,
    ConductorManagementDialogComponent,
    PropertySameCodeEditDialogComponent,
  ]
})
export class PropertiesModule { }
